import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { glyphs, useMediaQuery } from "../../../Styles";
import { Button, ProgressSteps, NewModal, MainContentPaddingTypes, ReportModalLvl1, ReportModalLvl2, ReportModalLvl3 } from "../..";

//TODO
import { ReportData, ReportTemplate } from "../../../Definitions/valueTypes";

interface TemplateModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
  report?: ReportData
  template?: ReportTemplate 
}

export default function TemplateModal({isModalOpen, closeModal, report, template}:TemplateModal_Props) {
  const {t} = useTranslation()
  const [currentTemplateLevel, setCurrentTemplateLevel] = useState(1);
  const [reportData, setReportData] = useState<ReportData|undefined>({name: undefined, archived: undefined, startDate: undefined, endDate: undefined, dataLevel: undefined, filterParameter: [[]]})
  const [templateData, setTemplateData] = useState<ReportTemplate|undefined>({name: undefined, dataLevel: undefined, filterParameter: [[]]})
  const mobileXs = useMediaQuery(`(max-width: 805px)`);

  useEffect(() => {
    if (isModalOpen && template) {
      setReportData({
        dataLevel: template.dataLevel,
        filterParameter: template.filterParameter,
        dataParameter: template.dataParameter,
      });
      setTemplateData({
        name: template.name
      })
    }
    setCurrentTemplateLevel(1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen])
  
  console.log("report", reportData)

  // Handle template level
  const TemplateLevel = (level: 0 | 1 | 2 | 3) => {
    setCurrentTemplateLevel(level);
  };
  
  // Handle "go back"
  const onGoBack = () => {
    if (currentTemplateLevel === 3) {
      TemplateLevel(2); // Go back to Level 2
    } else if (currentTemplateLevel === 2) {
      TemplateLevel(1); // Go back to Level 1
    } 
  }
    
  return (
    <NewModal 
      modalState={isModalOpen}
      overrides={{ 
        mainContentPadding: MainContentPaddingTypes.secondary,
        headerContentHeight: "65px"
      }}
      predefinedButtons={{
        onClose: () => { closeModal(); setTemplateData(undefined);  setReportData(undefined)},
        onGoBack: currentTemplateLevel === 2 || currentTemplateLevel === 3? onGoBack : undefined
      }}
      header={t("reportPages.reports.newReport", { defaultValue: "new report" })}
      subHeader={template ? `${t("reportPages.reports.fromTemplate", {defaultValue: "from template"})} ${template.name}` : ""}
      headerContent={
        <ProgressSteps 
          titles={[t("reportPages.reports.dataLevel", {defaultValue: "data level"}), t("reportPages.reports.filterParameter", {defaultValue: "filter parameter"}), t("reportPages.reports.dataParameter", {defaultValue: "data parameter"})]} 
          icons={[glyphs.Animal({}), glyphs.Animal({}), glyphs.Animal({})]} opacityValues={currentTemplateLevel === 1 ? [1, 0.5, 0.5] : currentTemplateLevel === 2 ? [0.5, 1, 0.5] : [0.5, 0.5, 1] }
        />
      }
      secondaryContent={
        <div style={{ width: mobileXs ? "290px" : "615px" }}>
          {currentTemplateLevel === 1 && <ReportModalLvl1 reportData={reportData} onReportDataChange={setReportData}/>}
          {currentTemplateLevel === 2 && <ReportModalLvl2 reportData={reportData} onReportDataChange={setReportData}/>}
          {currentTemplateLevel === 3 && <ReportModalLvl3 reportData={reportData} onReportDataChange={setReportData}/>} 
        </div>}
      mainContent={
        <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
          <Button 
            content={currentTemplateLevel === 1||currentTemplateLevel === 2 ? t("buttons.next", {defaultValue: "next"}) : t("reportPages.reports.createReport", {defaultValue: "create report"})}
            onClick={currentTemplateLevel === 1 ? () => TemplateLevel(2) : currentTemplateLevel === 2 ? () => TemplateLevel(3) : () => closeModal() } // TODO CTO: On closeModal() also save to db/create report
          />
        </div>
      }
    />
  );
}